import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import Landing from './pages/PagesLanding/landing';
import Form from './pages/PagesLanding/form/form';
import Dashboard from './pages/PagesDashboard/PagesDashboard';
import Login from './pages/Auth/login';
import { UserAuthContextProvider } from './core/providers/UserAuthContext';
import ProtectedRoute from './pages/protected/ProtectedRoute';
import Home from './pages/PagesDashboard/Home/Home';
import Codigos from './pages/PagesDashboard/Codigos/Codigos';
import Formularios from './pages/PagesDashboard/Formularios/Formularios';
import FormularioDetalle from './pages/PagesDashboard/FormularioDetalle/FormularioDetalle';
import ContactoPage from './pages/PagesLanding/contacto/ContactoPage';
import FinanciacionPage from './pages/PagesLanding/financiacion/FinanciacionPage';
import SolicitudAsiloPage from './pages/PagesLanding/pages/SolicitudAsiloPage';
import PeticionesFamiliaresPage from './pages/PagesLanding/pages/PeticionesFamiliaresPage';
import ContactenosPage from './pages/PagesDashboard/Contactenos/ContactenosPage';

function App() {
    return (
        <UserAuthContextProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/formulario" element={<Form />} />
                    <Route path="/financiacion" element={<FinanciacionPage />} />
                    <Route path="/contacto" element={<ContactoPage />} />
                    <Route path="/solicitud-asilo" element={<SolicitudAsiloPage />} />
                    <Route path="/peticiones-familiares" element={<PeticionesFamiliaresPage />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/dashboard" element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    } >
                        <Route path="home" element={<Home />} />
                        <Route path="codigos" element={<Codigos />} />
                        <Route path="formularios" element={<Formularios />} />
                        <Route path="ver-formulario/:id" element={<FormularioDetalle />} />
                        <Route path="contactenos" element={<ContactenosPage />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </UserAuthContextProvider>
    );
}

export default App;